import {Component, OnInit} from '@angular/core';
import {NavigationExtras, Router} from '@angular/router';
import {AlertController, ModalController, Platform} from '@ionic/angular';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {FavoritoService} from '../../shared/services/favorito.service';
import {Estacao} from '../../shared/models/estacao.model';
import {BuscarEstacoesComponent} from '../buscar-estacoes/buscar-estacoes.component';

@Component({
  selector: 'app-estacoes-favoritas',
  templateUrl: './estacoes-favoritas.page.html',
  styleUrls: ['./estacoes-favoritas.page.scss'],
})
export class EstacoesFavoritasPage implements OnInit {
  private isDesktop: boolean;
  private prefixoRota: string;
  estacoesFavoritas: Estacao[] = [];
  estacaoPrincipal: Estacao;

  constructor(private router: Router,
              private platform: Platform,
              private modalCtrl: ModalController,
              private alertController: AlertController,
              private favoritosService: FavoritoService) {
    this.isDesktop = this.platform.is('desktop') &&
      !this.platform.is('mobile') &&
      !this.platform.is('mobileweb');
    this.prefixoRota = this.isDesktop ? '' : '/tabs';
    this.favoritosService.change$.subscribe(data => this.atualizarDadosFavoritos(data));
  }

  carregarFavoritos() {
    this.favoritosService.init().then(data => {
      this.atualizarDadosFavoritos(data);
    });
  }

  private atualizarDadosFavoritos(data) {
    this.estacaoPrincipal = null;
    this.estacoesFavoritas = [];
    if (data) {
      const principal = data.filter(e => e != null && e.isPrincipal);
      if (principal && principal[0]) {
        this.estacaoPrincipal = principal[0];
      }
      this.estacoesFavoritas = data.filter(e => e != null && !e.isPrincipal);
    }
  }

  ngOnInit() {
    this.carregarFavoritos();
  }

  voltar() {
    this.router.navigate([`${this.prefixoRota}/painel`]);
  }

  async drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.estacoesFavoritas, event.previousIndex, event.currentIndex);
    const estacoes = [...this.estacoesFavoritas];
    estacoes.push(this.estacaoPrincipal);
    await this.favoritosService.atualizarOrdem(estacoes);
  }

  cancelar() {
    this.router.navigate([`${this.prefixoRota}/painel`]);
  }

  async confirmRemoverFavorito(estacao: Estacao) {
    const alert = await this.alertController.create({
      header: 'Remover estação favorita',
      message: 'Deseja realmente remover a estação <b>' + estacao.noEstacao + '</b>?',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary',
        }, {
          text: 'Sim',
          handler: () => {
            this.favoritosService.desfavoritarEstacao(estacao);
            this.carregarFavoritos();
          }
        }
      ]
    });

    await alert.present();
  }

  async buscarFavorito(isPrincipal?: boolean) {
    const modal = await this.modalCtrl.create({
      component: BuscarEstacoesComponent,
      componentProps: {isEstacaoPrincial: isPrincipal},
      cssClass: 'modal-pesquisa'
    });
    modal.onDidDismiss().then((response) => {
      if (response.data) {
        let navigationExtras: NavigationExtras = {
          queryParams: {}
        };
        if (response.data.verNoMapa) {
          this.router.navigate([`${this.prefixoRota}/mapa`]);
        }
        if (response.data.localAtual) {
          navigationExtras.queryParams.localAtual = true;
          this.router.navigate([`${this.prefixoRota}/mapa`], navigationExtras);
        } else if (response.data && response.data.estacao) {
          let estacao: Estacao = response.data.estacao;
          estacao.isPrincipal = isPrincipal;
          this.favoritosService.favoritarEstacao(estacao);
          this.carregarFavoritos();
        }
      }
    });
    modal.present();
  }
}
